export const jobPositionsKey = 'jobPositions';
export const errorMessage = 'Sorry, something went wrong';
